import { Component } from '@angular/core';
import { Events, NavController } from 'ionic-angular';
import { CadastroPage } from '../cadastro/cadastro';
import { LoginPage } from '../login/login';
import { VerMapaPage } from '../../pages/vermapa/vermapa';
import { Facebook } from '@ionic-native/facebook';
import { GooglePlus } from '@ionic-native/google-plus';
import { AuthService } from '../../providers/auth-service';

@Component({
  selector: 'entrar',
  templateUrl: 'entrar.html'
})
export class EntrarPage {

	public cadastroPage = CadastroPage;
	public loginPage = LoginPage;

	constructor(private fb: Facebook, private googlePlus: GooglePlus, public auth: AuthService, public events: Events, private navCtrl: NavController) {

		this.events.subscribe('user:exists', () => {
			this.navCtrl.push(VerMapaPage);
		});
	}

	facebookLogin() {
		this.fb.login(['public_profile', 'user_friends', 'email']).then(res => {
			if(res.status === "connected") {
				this.fb.api("/"+res.authResponse.userID+"/?fields=id,email,name,gender",["public_profile"]).then(res => {

					this.auth.userExists(res.email);

					if(!localStorage.getItem("idUsuario"))
						this.navCtrl.push(CadastroPage, {nome: res.name, email: res.email, origem: "facebook"});
			    });
			} else {
				alert("Não foi possível se conectar. Por favor, tente novamente.");
			}
		}).catch(e => console.log("error: "+e.errorMessage));
	}

	googleLogin() {
		this.googlePlus.login({})
  			.then(
				res => {
					this.auth.userExists(res.email);

					if(!localStorage.getItem("idUsuario"))
						this.navCtrl.push(CadastroPage, {nome: res.displayName, email: res.email, origem: "google"});
				}
			)
  			.catch(err => console.log(err));
	}
}


// WEBPACK FOOTER //
// ./src/pages/entrar/entrar.ts